<script setup>
import { call } from '@/clients/internalClient';
import {ref, inject} from 'vue'
import Icon from '../Icon.vue';
import Dropdown from '../components/Dropdown.vue';
import TitleText from '../components/TitleText.vue';
import { newDocument, newWizard } from '../actions/documentActions';
import ThemeSwitcher from '../components/ThemeSwitcher.vue';
import { placeholdAction } from '../editor/actions/placeholderAction';
import Button from '../components/Button.vue';
import { LocalProps } from '../localProps';
import { debugAuth, logout } from '../actions/appActions';
import AwarenessPeers from '../awareness/AwarenessPeers.vue';
import StarDoc from '../components/StarDoc.vue';
import Payment from '../payments/Payment.vue';
import QuickMenu from './QuickMenu.vue';
import { checkout } from '../payments/paymentActions';

const userInfo = inject('userInfo')
const resonsiveChatMode = inject('resonsiveChatMode')
const billing = inject('billing');

const isWizard = inject('wizardMode');

</script>

<template>
  <div class="header">
    <Button title="open/close side bar" @action="LocalProps.toggle(LocalProps.SIDEBAR)" class="btn-ghost btn-sm px-1 "><Icon name="heroicons-outline--menu" :size="24"/></Button>
    <slot name="leftExtention" />
    <template v-if="!isWizard">
      <TitleText class="ml-2" style="flex: 1"/>
      <StarDoc class="pr-2"/>     
    </template>
    <div v-else style="flex: 1"></div>

    <div class="gap-1 items-center flex">
      <AwarenessPeers class="desktop-bar"/>
      <!-- <Button @action="placeholdAction" class="btn btn-sm btn-primary desktop-bar">Share</Button> -->
      <Button v-if="! billing?.subscription" title="Upgrade to pro plan" @action="checkout('subscription')" class="btn-sm btn-ghost px-2"><Icon name="octicon--sparkle-16" size="16"/>Upgrade</Button>

      <Dropdown class="btn btn-sm btn-ghost" placement="bottom">
        <template #button>                  
          <Icon name="heroicons--ellipsis-horizontal-16-solid" size="20" class="mobile-only"/>          
          <span class="desktop-only" style="display: flex; align-items: center; gap: 4px">{{ userInfo.name }} <Icon name="octicon--chevron-down-16" size="20" class="desktop-only"/>          </span>
        </template>    
        <template #content>
          <QuickMenu />
        </template>    
      </Dropdown>      
      <div class="border-l-1 border-neutral-content desktop-bar"></div>
      <div class="gap-1 flex desktop-bar">
        <!-- <Button @action="placeholdAction" class="btn btn-sm btn-ghost px-2"><Icon name="iconoir--search" size="20"/></Button>
        <Button @action="placeholdAction" class="btn btn-sm btn-ghost px-2"><Icon name="iconoir--bell" size="20"/></Button> -->
        <Button title="create empty doc" @action="() => newDocument(userInfo.uid)" class="btn-sm btn-ghost px-2"><Icon name="heroicons--plus" size="20"/></Button>
        <Button v-if="!isWizard" title="compose new doc with AI" @action="newWizard" class="btn-sm btn-primary px-2"><Icon name="wand" size="20"/>New Doc</Button>
      </div>  
    </div>
  </div>
</template>

<style scoped lang="less">
  .header {
    overflow-x: auto;
    padding: 8px 10px 8px 5px;

    display: flex;
    align-items: center
  }

  .desktop-bar {
    
    @media (max-width: (@light-mode-bp - 1px)) { 
      & {
        display: none;
      }
    }
  }

  .mobile-only {
    
    @media (min-width: (@light-mode-bp)) { 
      & {
        display: none;
      }
    }
  }
  .desktop-only {
    
    @media (max-width: (@light-mode-bp - 1px)) { 
      & {
        display: none;
      }
    }
  }

</style>
